import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import { EnrollmentActionContext } from "./EnrollmentActionContext";
import { t } from "i18next";
import EnrollPlayerForm from "@main/players/components/EnrollPlayerForm";

function useEnrollmentAction(index: any, formDefaultValues: any = {}): any {
  const initialize = useInitialize();
  const enrollmentInitializeFunction = () => initialize(formDefaultValues);

  /**
   * Form store success function definition
   */
  const onSuccessStore = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const store = useStore();
  const storeFunction = () => store(onSuccessStore);

  /** Creation and edition modal function and state definition */
  const { setShowModal } = useContext(EnrollmentActionContext);

  /** Creation and edition modal element definition */
  const { element } = useContext(EnrollmentActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: t("mark_as_paid"),
    context: EnrollmentActionContext,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      storeFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: EnrollmentActionContext,
    className: "enroll-player-form",
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <EnrollPlayerForm formConfig={formConfig} />
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    enrollmentInitializeFunction,
    actionTemplate,
  };
}

export default useEnrollmentAction;
